var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"speech-text-button",on:{"click":_vm.playText}},[_vm._v("▸")])}
var staticRenderFns = []

export { render, staticRenderFns }